var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'div-padd': _vm.addPadding }},[_c('canvas',{ref:"canvas",staticStyle:{"width":"100%","min-width":"20vw"}})])}
var staticRenderFns = []

export { render, staticRenderFns }